module.exports = __webpack_public_path__ + "img/back exposed 10mm zipper length.ac57f80b.png";